package com.castly.shared.dto

import kotlinx.serialization.Serializable

/**
 * Home Section DTO for client-facing API responses
 * Matches OpenAPI schema from contracts/home-api.yaml
 */
@Serializable
data class HomeSectionDto(
    val id: String,
    val type: String, // "carousel", "episode_carousel", "banner", or "static"
    val displayOrder: Int,

    // Carousel fields
    val title: String? = null,
    val description: String? = null,
    val contentType: String? = null, // "podcast" or "audiobook"
    val items: List<CarouselItemDto>? = null,

    // Banner fields
    val imageUrl: String? = null,
    val link: String? = null,

    // Static fields
    val vendorId: String? = null
)

/**
 * Content-level engagement (aggregated across all episodes of a content item)
 * Mirrors EpisodeEngagement structure for consistency
 */
@Serializable
data class ContentEngagement(
    val isContinueWatching: Boolean,
    val consumedSeconds: Int,
    val totalDurationSeconds: Int?,
    val progressPercent: Int?
)

/**
 * Carousel Item DTO for items within carousel sections
 */
@Serializable
data class CarouselItemDto(
    val id: String,
    val type: String, // "podcast", "audiobook" or "episode"
    val title: String,
    val description: String? = null,
    val coverArt: String? = null,
    val author: String? = null,
    val createdAt: String,
    val isLiked: Boolean = false,
    val totalDurationSeconds: Int? = null,
    val engagement: ContentEngagement? = null,

    // Episode items only (type = "episode"): the parent podcast/audiobook
    val contentId: String? = null,
    val contentType: String? = null, // "podcast" or "audiobook"
    val contentTitle: String? = null,
    val episodeNumber: Int? = null
)

/**
 * Home Page Response DTO
 */
@Serializable
data class HomePageResponse(
    val sections: List<HomeSectionDto>
)
